(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion-item"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('accordion-group')) {
    customElements.define(
      'accordion-group',
      class AccordionGroup extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', (event) => {
            const trigger = event.target.closest('[data-accordion-trigger]');
            if (!trigger || !this.contains(trigger)) return;
            this.toggle(trigger, trigger.getAttribute('aria-expanded') !== 'true');
          });
        }

        get triggers() {
          return [...this.querySelectorAll('[data-accordion-trigger]')];
        }

        toggle(trigger, open) {
          const single = !this.hasAttribute('data-multiple');
          this.triggers.forEach((other) => {
            if (other !== trigger && !single) return;
            const isTarget = other === trigger && open;
            other.setAttribute('aria-expanded', String(isTarget));
            document.getElementById(other.getAttribute('aria-controls'))?.classList.toggle('is-open', isTarget);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["buy-box"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-buy')) {
    customElements.define(
      'product-buy',
      class ProductBuy extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('[data-buy-form]');
          this.qty = this.querySelector('[data-qty]');
          this.addBtn = this.querySelector('[data-add]');
          this.addText = this.querySelector('[data-add-text]');
          this.status = this.querySelector('[data-status]');
          this.unitPriceEl = this.querySelector('[data-unit-price]');
          this.perCupEl = this.querySelector('[data-per-cup]');
          this.sticky = this.querySelector('[data-sticky]');
          this.stickyPrice = this.querySelector('[data-sticky-price]');
          this.stickyAdd = this.querySelector('[data-sticky-add]');
          this.variantInput = this.querySelector('[data-variant-input]');
          this.packInputs = [...this.querySelectorAll('[data-packs] input[name="quantity"]')];
          this.available = this.variantInput ? this.variantInput.dataset.available !== 'false' : true;

          if (this.form) {
            this.querySelectorAll('[data-qty-step]').forEach((btn) =>
              btn.addEventListener('click', () => this.stepQty(Number(btn.dataset.qtyStep)))
            );
            this.qty?.addEventListener('input', () => this.updateTotal());
            this.qty?.addEventListener('change', () => {
              this.clampQty();
              this.updateTotal();
            });
            this.form.addEventListener('change', (event) => {
              if (event.target.name === 'id' || event.target.name === 'quantity') this.updateTotal();
              if (event.target.dataset.optionIndex !== undefined) this.onOptionChange();
            });
            this.form.addEventListener('submit', (event) => this.submit(event));
            this.updateTotal();
          }

          this.waitlist = this.querySelector('.buy__waitlist');
          this.anchor = this.form ? this.addBtn : this.waitlist;
          if (this.sticky && this.anchor) {
            this.stickyAdd?.addEventListener('click', () => this.form.requestSubmit());
            this.querySelector('[data-sticky-waitlist]')?.addEventListener('click', () => this.focusWaitlist());
            // Visibility comes from IntersectionObservers (entry geometry is
            // free), so scrolling never forces a layout read. The button is
            // watched against a viewport stretched endlessly downward: its only
            // non-intersecting state is "scrolled above the top", so a jump past
            // it (an anchor link, a restored scroll) still fires a callback.
            this.footer = document.querySelector('.section-footer, footer');
            this.anchorAbove = false;
            this.anchorVisible = true;
            this.footerVisible = false;
            this.offscreenMode = this.dataset.stickyMode === 'offscreen';
            this.anchorObserver = new IntersectionObserver(
              ([entry]) => {
                this.anchorAbove = !entry.isIntersecting;
                this.updateSticky();
              },
              { rootMargin: '0px 0px 100000px 0px' }
            );
            // Product page: also watch the row against the real viewport, so the bar shows while it is below the fold too.
            if (this.offscreenMode) {
              this.anchorVisible = false;
              this.visibleObserver = new IntersectionObserver(([entry]) => {
                this.anchorVisible = entry.isIntersecting;
                this.updateSticky();
              });
              this.visibleObserver.observe(this.anchor);
            }
            // Out of the way of an open drawer (both toggle html.is-scroll-locked) and of Shopify's cookie banner.
            this.rootObserver = new MutationObserver(() => this.updateSticky());
            this.rootObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
            this.onConsent = () => this.updateSticky();
            document.addEventListener('visitorConsentCollected', this.onConsent);
            this.anchorObserver.observe(this.anchor);
            this.observer = new IntersectionObserver(([entry]) => {
              this.footerVisible = entry.isIntersecting;
              this.updateSticky();
            });
            if (this.footer) this.observer.observe(this.footer);
            this.onResize = () => this.updateSticky();
            window.addEventListener('resize', this.onResize, { passive: true });
            this.updateSticky();
          }
        }

        disconnectedCallback() {
          this.observer?.disconnect();
          this.anchorObserver?.disconnect();
          this.visibleObserver?.disconnect();
          this.rootObserver?.disconnect();
          document.removeEventListener('visitorConsentCollected', this.onConsent);
          window.removeEventListener('resize', this.onResize);
        }

        get variants() {
          if (!this._variants) {
            const data = this.querySelector('[data-variants]');
            this._variants = data ? JSON.parse(data.textContent) : [];
          }
          return this._variants;
        }

        onOptionChange() {
          const selected = [...this.form.querySelectorAll('[data-option-index]:checked')]
            .sort((a, b) => a.dataset.optionIndex - b.dataset.optionIndex)
            .map((input) => input.value);
          const variant = this.variants.find((v) => v.options.every((value, i) => value === selected[i]));
          this.applyVariant(variant || null);
        }

        // Point the form at a variant (or at none, when the chosen options
        // don't exist): price, per cup, availability, the button and the URL.
        applyVariant(variant) {
          if (!this.variantInput) return;
          if (variant) {
            this.variantInput.value = String(variant.id);
            this.variantInput.dataset.priceCents = String(variant.price);
          }
          this.available = Boolean(variant && variant.available);
          this.variantInput.dataset.available = String(this.available);
          this.addBtn.disabled = !this.available;
          if (this.stickyAdd) {
            this.stickyAdd.disabled = !this.available;
            this.stickyAdd.textContent = this.available ? this.addBtn.dataset.label : this.dataset.soldOut;
          }
          if (variant && this.hasAttribute('data-update-url')) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url);
          }
          this.updateTotal();
        }

        priceCents() {
          const checked = this.form.querySelector('input[name="id"]:checked') || this.form.querySelector('input[name="id"]');
          return Number(checked?.dataset.priceCents || 0);
        }

        selectedPack() {
          return this.packInputs.find((input) => input.checked) || null;
        }

        clampQty() {
          if (!this.qty) return 1;
          const min = Number(this.qty.min) || 1;
          const max = Number(this.qty.max) || 99;
          let value = Math.round(Number(this.qty.value) || min);
          value = Math.min(max, Math.max(min, value));
          this.qty.value = String(value);
          return value;
        }

        stepQty(delta) {
          if (!this.qty) return;
          this.qty.value = String((Number(this.qty.value) || 1) + delta);
          this.clampQty();
          this.updateTotal();
        }

        formatMoney(cents) {
          const format = this.dataset.moneyFormat || '$';
          const [whole, decimals] = (cents / 100).toFixed(2).split('.');
          const group = (sep) => whole.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
          const values = {
            amount: `${group(',')}.${decimals}`,
            amount_no_decimals: group(','),
            amount_with_comma_separator: `${group('.')},${decimals}`,
          };
          const placeholder = /\{\{\s*(\w+)\s*\}\}/;
          if (!placeholder.test(format)) return `${format}${values.amount}`;
          return format.replace(placeholder, (match, key) => values[key] ?? values.amount);
        }

        // Price, price per cup, the button and the sticky bar follow the chosen pack
        // (pack total = unit price x pouches, less that pack's automatic discount).
        updateTotal() {
          const pack = this.selectedPack();
          const qty = pack ? Number(pack.value) : Math.max(1, Math.round(Number(this.qty?.value) || 1));
          const unit = this.priceCents();
          const totalCents = Math.max(0, unit * qty - Number(pack?.dataset.savingCents || 0));
          const total = this.formatMoney(totalCents);
          if (this.unitPriceEl) this.unitPriceEl.textContent = this.formatMoney(pack ? totalCents : unit);
          if (this.perCupEl) {
            const cups = Number(this.perCupEl.dataset.cups) * (pack ? qty : 1);
            if (cups > 0) {
              const perCup = this.formatMoney(Math.round((pack ? totalCents : unit) / cups));
              this.perCupEl.textContent = this.perCupEl.dataset.template.replace('[price]', perCup);
            }
          }
          if (this.addText) {
            this.addText.textContent = this.available ? `${this.addBtn.dataset.label} · ${total}` : this.dataset.soldOut;
          }
          if (this.stickyPrice) this.stickyPrice.textContent = pack ? `${pack.dataset.packName} · ${total}` : total;
        }

        async submit(event) {
          event.preventDefault();
          if (!this.available) return;
          const pack = this.selectedPack();
          const quantity = pack ? Number(pack.value) : this.clampQty();
          const idInput = this.form.querySelector('input[name="id"]:checked') || this.form.querySelector('input[name="id"]');
          if (!idInput) return;
          this.addBtn.disabled = true;
          this.addBtn.setAttribute('aria-busy', 'true');
          this.status.textContent = '';
          try {
            // The Founding 50 gift rides in the same request as the tea, so the two land together.
            const tea = { id: Number(idInput.value), quantity };
            const add = (items) =>
              fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items }),
              });
            const extra = window.Ovali?.giftItems?.() || [];
            let response = await add([tea, ...extra]);
            // The gift sold out since the page loaded: still add the tea.
            if (!response.ok && extra.length) response = await add([tea]);
            const data = await response.json();
            if (!response.ok) throw new Error(data.description || data.message || this.dataset.error);
            let cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
            if (window.Ovali?.reconcileGift) cart = (await window.Ovali.reconcileGift(cart)).cart;
            this.updateCartCount(window.Ovali?.cartCount ? window.Ovali.cartCount(cart) : cart.item_count);
            this.status.textContent = this.dataset.addedStatus;
            if (this.addText) {
              this.addText.textContent = `${this.dataset.addedLabel} ✓`;
              this.swapIn(this.addText);
            }
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
            window.setTimeout(() => {
              this.updateTotal();
              if (this.addText) this.swapIn(this.addText);
            }, 2200);
          } catch (error) {
            this.status.textContent = error.message || this.dataset.error;
          } finally {
            this.addBtn.disabled = !this.available;
            this.addBtn.removeAttribute('aria-busy');
          }
        }

        // The new label rises into place, so the confirmation reads as a moment, not a flicker.
        swapIn(el) {
          if (window.Ovali?.reducedMotion?.matches || !el.animate) return;
          el.animate(
            [
              { opacity: 0, transform: 'translateY(40%)' },
              { opacity: 1, transform: 'none' },
            ],
            { duration: 450, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' }
          );
        }

        updateCartCount(count) {
          document.querySelectorAll('[data-cart-count]').forEach((el) => {
            el.textContent = String(count);
            el.hidden = count === 0;
          });
          const link = document.getElementById('HeaderCartLink');
          const label = document.querySelector('[data-cart-label]');
          if (link && label) {
            const template = count === 1 ? link.dataset.labelOne : link.dataset.labelOther;
            if (template) label.textContent = template.replace('[count]', String(count));
          }
        }

        updateSticky() {
          if (window.matchMedia('(min-width: 990px)').matches) {
            this.setSticky(false);
            return;
          }
          const signedUp = this.waitlist && this.waitlist.querySelector('[data-success]')?.hidden === false;
          if (signedUp) {
            this.setSticky(false);
            return;
          }
          const out = this.offscreenMode ? !this.anchorVisible : this.anchorAbove;
          const drawerOpen = document.documentElement.classList.contains('is-scroll-locked');
          const banner = document.getElementById('shopify-pc__banner');
          const bannerUp = Boolean(banner && banner.offsetParent !== null);
          this.setSticky(out && !this.footerVisible && !drawerOpen && !bannerUp);
        }

        focusWaitlist() {
          const input = this.waitlist.querySelector('input[type="email"]');
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.waitlist.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
          input?.focus({ preventScroll: true });
        }

        setSticky(show) {
          if (this.sticky.classList.contains('is-visible') === show) return;
          this.sticky.classList.toggle('is-visible', show);
          this.sticky.inert = !show;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-contents"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-items')) {
    customElements.define(
      'cart-items',
      class CartItems extends HTMLElement {
        connectedCallback() {
          // The gift check on page load fixed the cart: show the fixed copy.
          this.onGift = (event) => {
            if (event.detail?.source === 'gift') this.refresh();
          };
          document.addEventListener('cart:changed', this.onGift);
          this.addEventListener('click', (event) => {
            const step = event.target.closest('[data-cart-step]');
            const remove = event.target.closest('[data-cart-remove]');
            if (step) {
              const input = this.querySelector(`[data-cart-qty][data-line="${step.dataset.line}"]`);
              const next = Math.max(0, (Number(input.value) || 0) + Number(step.dataset.cartStep));
              this.change(step.dataset.line, next, step);
            } else if (remove) {
              event.preventDefault();
              this.change(remove.dataset.line, 0, remove);
            }
          });
          this.addEventListener('change', (event) => {
            const input = event.target.closest('[data-cart-qty]');
            if (input) this.change(input.dataset.line, Math.max(0, Math.round(Number(input.value) || 0)), input);
          });
        }

        disconnectedCallback() {
          document.removeEventListener('cart:changed', this.onGift);
        }

        async sectionHtml() {
          const sectionId = this.dataset.sectionId;
          const data = await fetch(`${window.location.pathname}?sections=${sectionId}`).then((r) => r.json());
          return data[sectionId];
        }

        async refresh() {
          try {
            this.swap(await this.sectionHtml(), '');
          } catch (error) {
            // Keep the current copy.
          }
        }

        async change(line, quantity, control) {
          const sectionId = this.dataset.sectionId;
          const focusKey = control ? `${control.dataset.cartStep !== undefined ? 'step' + control.dataset.cartStep : control.hasAttribute('data-cart-remove') ? 'remove' : 'qty'}-${line}` : '';
          this.classList.add('is-busy');
          try {
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ line: Number(line), quantity, sections: [sectionId], sections_url: window.location.pathname }),
            });
            let cart = await response.json();
            if (!response.ok) throw new Error(cart.description || cart.message);
            let html = cart.sections?.[sectionId];
            // Keep the Founding 50 gift in step: added with the first tea, gone with the last.
            const fixed = window.Ovali?.reconcileGift ? await window.Ovali.reconcileGift(cart) : null;
            if (fixed?.changed) {
              cart = fixed.cart;
              html = await this.sectionHtml();
            }
            CartItems.updateCount(window.Ovali?.cartCount ? window.Ovali.cartCount(cart) : cart.item_count);
            this.swap(html, focusKey);
            document.dispatchEvent(new CustomEvent('cart:changed', { detail: { cart, source: sectionId } }));
          } catch (error) {
            this.classList.remove('is-busy');
            const status = this.querySelector('[data-cart-status]');
            if (status) status.textContent = error.message || '';
          }
        }

        // Swap in the section's fresh cart, then put focus back where it was.
        swap(html, focusKey) {
          if (!html) return;
          const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-items]');
          if (!fresh) return;
          this.innerHTML = fresh.innerHTML;
          this.classList.remove('is-busy');
          const [kind, line] = (focusKey || '').split('-');
          let target = null;
          if (kind === 'qty') target = this.querySelector(`[data-cart-qty][data-line="${line}"]`);
          else if (kind && kind.startsWith('step')) target = this.querySelector(`[data-cart-step="${kind.slice(4)}"][data-line="${line}"]`);
          target = target || this.querySelector('[data-cart-qty], .cart__empty .btn');
          target?.focus({ preventScroll: true });
          const status = this.querySelector('[data-cart-status]');
          if (status) status.textContent = this.dataset.updated || '';
        }

        static updateCount(count) {
          document.querySelectorAll('[data-cart-count]').forEach((el) => {
            el.textContent = String(count);
            el.hidden = count === 0;
          });
          const link = document.getElementById('HeaderCartLink');
          const label = document.querySelector('[data-cart-label]');
          if (link && label) {
            const template = count === 1 ? link.dataset.labelOne : link.dataset.labelOther;
            if (template) label.textContent = template.replace('[count]', String(count));
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["customer-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('customer-form')) {
    // Read once, before the first form strips customer_posted from the URL.
    const postedOnLoad = new URLSearchParams(window.location.search).get('customer_posted') === 'true';

    customElements.define(
      'customer-form',
      class CustomerForm extends HTMLElement {
        connectedCallback() {
          const fields = this.querySelector('[data-fields]');
          const error = this.querySelector('[data-error]');
          const success = this.querySelector('[data-success]');
          const posted = postedOnLoad;
          const hasError = error && !error.hidden;
          if (!posted && !hasError) return;

          const isThisForm = window.location.hash === `#${this.dataset.formId}`;
          if (!isThisForm) {
            fields.hidden = false;
            success.hidden = true;
            error.hidden = true;
            return;
          }

          if (posted) {
            fields.hidden = true;
            success.hidden = false;
            success.focus({ preventScroll: true });
            this.publish();
            const url = new URL(window.location.href);
            url.searchParams.delete('customer_posted');
            window.history.replaceState(window.history.state, '', url);
          }
        }

        publish() {
          const name = this.dataset.event;
          if (!name) return;
          const send = () => {
            if (!window.Shopify?.analytics?.publish) return false;
            window.Shopify.analytics.publish(name, {});
            return true;
          };
          if (!send()) window.addEventListener('load', send, { once: true });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
